import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import '../styles/home.css';
import axios from 'axios';
import RingbaPubForm from '../components/forms/RingbaPubForm';
import RingbaPubTable from '../components/tables/RingaPubTable';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function Ringba() {
  const [formData, setFormData] = useState({
    affiliate_id: '',
    sub_affiliate: '',
    campaign_id: '',
    creative_id: '',
    payout: '',
    affiliate_payout: '',
    target: ''
  });
  const [loadingData, setLoadingData] = useState(true);

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handleFormChange = (fieldName, value) => {
    // Update the form data
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
  };

  const handleCreatePub = (e) => {
    e.preventDefault();
    console.log(formData)

    axios.post('https://emaildrop.com/ringba/addPublisher', formData , {})
      .then(() => {
        handleClose();
        setLoadingData(true);
      })
  };

  return (
    <Container className="dashboard">
      <h1>Ringba Manager</h1>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <RingbaPubForm formData={formData} onFormChange={handleFormChange} handleCreatePub={handleCreatePub}  />
        </Box>
      </Modal>
      <div className="text-center">
      <Button onClick={() => setOpen(true)}>Add New Pub</Button>
      </div>
      <div>
        <RingbaPubTable loadingData={loadingData} setLoadingData={setLoadingData}/>
      </div>
    </Container>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

